import { validateJson } from './validation';

export const parseStringTojson = (str) => {
  const isValidJson = validateJson(str);

  if (!isValidJson) {
    return str;
  }

  return JSON.parse(str);
};
